import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

// Envíos de pedidos con ConEnvios (cotizar, generar guía, imprimir rótulo)
export default {
    calculateShipping(payload) {
        return axios.post(`${API_URL}/shopify/orders/shipping/calculate`, payload, { headers: authHeader() });
    },
    generateWaybill(payload) {
        return axios.post(`${API_URL}/shopify/orders/shipping/waybill`, payload, { headers: authHeader() });
    },
    getWaybillPdf(ids) {
        return axios.post(`${API_URL}/shopify/orders/shipping/waybill-pdf`, { ids }, { headers: authHeader() });
    },
    getCarriers() {
        return axios.get(`${API_URL}/shopify/orders/shipping/carriers`, { headers: authHeader() });
    },
};
